module.exports = __webpack_public_path__ + "static/draft-banner-1383e7ad9e96188163873789b373df71.png";